import React, { useState } from 'react';
import WarningModal from '../../../../components/ConfirmationModal/WarningModal';
import { DataModelerConfigLabelWithInfo } from '../DataModelerShared';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import { InputField, VerticalField } from '../../../../components/Form';
import { parseTimeout } from './utils';

interface IProps {
  timeout: number | null;
  onChange: (newTimeout: number | null) => void;
  disabled: boolean;
}

const QueryTimeoutField = ({ timeout, onChange, disabled }: IProps) => {
  const [warningConfirmed, setWarningConfirmed] = useState(false);
  const [warningModalOpen, setWarningModalOpen] = useState(false);

  const handleConfirmWarning = () => {
    setWarningModalOpen(false);
    setWarningConfirmed(true);
  };

  const handleCancelWarning = () => {
    setWarningModalOpen(false);
  };

  const handleChangeValue = (newTimeoutStr: string) => {
    const newTimeout = parseTimeout(newTimeoutStr);

    if (
      !warningConfirmed &&
      timeout !== null &&
      newTimeout !== null &&
      newTimeout > timeout
    ) {
      setWarningModalOpen(true);
      return;
    }

    onChange(newTimeout);
  };

  return (
    <>
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'Query Timeout Seconds'}
          tooltipOption={dataModelLabelInfoTooltipOptions.connectionTimeout}
        />
        <InputField
          type="number"
          value={timeout ?? undefined}
          onChange={handleChangeValue}
          disabled={disabled}
          placeholder={'600'}
        />
      </VerticalField>
      {warningModalOpen && (
        <WarningModal
          onConfirm={handleConfirmWarning}
          onCancel={handleCancelWarning}
          trackContext="data modeler"
          trackConfirmAction="query timeout - confirm"
          trackCancelAction="query timeout - cancel"
        >
          Extending query timeout could significantly increase your warehouse
          compute costs. Are you sure you want to continue?
        </WarningModal>
      )}
    </>
  );
};

export default QueryTimeoutField;
